export default __webpack_public_path__ + "static/media/Smoothing-Trowel.3635a333.jpg";